// extracted by mini-css-extract-plugin
export default {"container":"YCaN2C","innerContainer":"H5tjni"};